import { render } from "./padel-calendar.template.html?vue&type=template&id=db70857a&scoped=true"
import script from "./PadelCalendar.vue?vue&type=script&lang=ts"
export * from "./PadelCalendar.vue?vue&type=script&lang=ts"

import "./PadelCalendar.vue?vue&type=style&index=0&id=db70857a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db70857a"

export default script